import { ajaxPromise } from './utilities/ajax.js';
import { queryString } from './utilities/string';
import { initSimditor } from "./utilities/init-simditor.js";
import { zeroPadding } from "./utilities/number";
const modal = require("tpl/tsmodal.html");
const logoArr = [
    {
        name: '新疆科协官网',
        url: 'https://www.xast.org.cn/'
    },
    {
        name: '科普新疆微信<br>公众号'
    },
    {
        name: '科普新疆抖音',
        url: 'https://www.douyin.com/user/MS4wLjABAAAA5NT-gODd1g3BBkXpoS1KOuuv58f_xWS0jk4maWAbnkOQokh_kWiqdR4GagHPlCn3'
    },
    {
        name: '科普新疆B站',
        url: 'https://space.bilibili.com/687059521?from=search&seid=14328362695558756207&spm_id_from=333.337.0.0'
    },
    {
        name: '科普新疆快手',
        url: 'https://www.kuaishou.com/profile/3x653bug6tsyk2c'
    },
    {
        name: '科普新疆微博',
        url: 'https://weibo.com/kpxj'
    },
    {
        name: '科普新疆今日头条',
        url: 'https://www.toutiao.com/c/user/token/MS4wLjABAAAAxupQtcgrUEtFEgxL1v-eRQtv-SBNnKo_av5MbUSj3oA/?'
    },
    {
        name: '石榴云'
    },
    {
        name: '新疆科协学习强国'
    },
    {
        name: '新疆广播电视台'
    },
    {
        name: '新疆日报'
    },
    {
        name: '中国电信<br>新疆分公司'
    },
    {
        name: '新疆广电网络'
    },
    {
        name: '中国移动<br>新疆分公司'
    },
    {
        name: '新疆文化出版社'
    },
    {
        name: '中国科学技术<br>出版社'
    },
    {
        name: '天山网',
        url: 'http://www.ts.cn/'
    }
]
const _data = {
    verifyCode: '', // 图形校验code
};
const __tsIndex = {
    page1: 1,
    page2: 1,
    scientificPage: 1,
    isfinsh1: false,
    isfinsh2: false,
    isMobileFlag: false,
    init() {
      let ind = 0
      $('.tabs-sidebar a').each((index,el)=>{
        // console.log($el.attr('class'))
        // console.log($(el))
        if($(el).attr('class') && $(el).attr('class').indexOf('active') != -1){
          ind = index
          // console.log($(el)[0].offsetLeft)
          $('.tabs-sidebar').scrollLeft($(el)[0].offsetLeft)
        }
        // console.log(el)
      })
      // console.log(ind)
      // $('.tabs-sidebar').scrollLeft(posiLeftList[ind] - (clientW / 2) + ($navList.eq(index).outerWidth() / 2));
    
        //  banner
        if ($('._bannerSwiper').length > 0) {
            this.initSwiper('._bannerSwiper', true);
        }
 
        __tsIndex.isMobileFlag = __tsIndex.isMobile()
        // 移动端
        if(__tsIndex.isMobileFlag){
            if ($('._demandList2').length) {
                new Swiper('._demandList2', {
                    loop: true,
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                    autoplay: 2000
                });
            }
            if($('._feedback_select').length){
                $('._feedback_select').remove()
            }
            //  org
            if ($('._recommendSwiper').length > 0) {
                // this.initSwiper('._recommendSwiper', true);
                // var swiper = new Swiper("._recommendSwiper", {
                //     pagination: {
                //       el: ".swiper-pagination",
                //     },
                //   });
                new Swiper('._recommendSwiper', {
                    loop: true,
                    paginationClickable: true,
                    pagination: '._pagination',
                    autoplay: 5000
                });
            }

        } else { // PC端
            if ($('._demandList').length) {
                new Swiper('._demandList', {
                    loop: true,
                    direction: 'vertical', //向上
                    slidesPerView: 8,
                    slidesPerGroup: 1,
                    autoplay: 2000
                });
            }
            if($('._feedback_radio').length){
                $('._feedback_radio').remove()
            }

        }


   

        if ($('#tsHeader').length > 0) {
            this.initScrollFun();
        }

        if ($('._cbSwiperWrapper').length > 0) {
            this.initLogoFun();
        }

        if ($('._sysSwiper1').length > 0) {
            this.ajaxGetSystemFun(1, 1, 18);
        }

        if ($('._sysSwiper2').length > 0) {
            this.ajaxGetSystemFun(2, 1, 6);
        }

        if ($('._tagCloudList').length > 0) {
            this.ajaxGetResourceFun(5);
        }

        if ($('._scientificList').length > 0) {
            this.initSearchItemHeightFun();
        }
        if ($('._showMore').length > 0) {
            this.initOrgSearchItemHeightFun();
        }

        if ($('.xf-toast').length > 0) {
            this.initToastPosFun();

            $(window).resize(function () {
                __tsIndex.initToastPosFun();
            });

        }

        if (queryString('scrollToNeeds') && window.location.pathname == '/tsindex') {
            __tsIndex.scrollToNeedsFun();
        }

        __tsIndex.checkUserMoblieFun();
        if($("._richEditorFeedback").length>0){
            $("._richEditorFeedback").initSimditor({
                toolbar: [
                    'title', 'bold', 'italic', 'underline', 'strikethrough', 'color', '|', 'ol', 'ul', 'alignment', 'blockquote'
                ],
                getValueSize: function (len) {
                    $('._richEditorCount').text(len);
                }
            });
        }
        __tsIndex.setDateCounter();

    },
    isMobile() {
        let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return mobile!= null
    },
    // 执行倒计时方法
    setDateCounter() {
        // 缓存一下列表。避免每次都
        var $counterList = $("._demandList").find("._counter");
        var couterDataObj = [];

        if (!$counterList.length) {
            return false;
        }
        // 把对应的项和他的倒计数放到一个数组中
        $counterList.each((index, item) => {
            __tsIndex.startDateCouter($(item), parseInt($(item).attr("data-rest")));
        });

    },
    getDateObjInSecond(restSeconds) {
        var days = Math.floor(restSeconds / (24 * 3600));
        var hours = Math.floor((restSeconds - days * 24 * 3600) / 3600);
        var minutes = Math.floor((restSeconds - days * 24 * 3600 - hours * 3600) / 60);
        var seconds = Math.floor((restSeconds - days * 24 * 3600 - hours * 3600 - minutes * 60) % 60);

        return {
            days,
            hours: zeroPadding(hours),
            minutes: zeroPadding(minutes),
            seconds: zeroPadding(seconds)
        }
    },
    startDateCouter(ele, time) {
        var couterHtml = ''
        var currTime = __tsIndex.getDateObjInSecond(time);

        // 如果当前的时间超过了一天的秒数。就显示为 xx天 + 剩余时分
        // 否则显示为 xx时：xx分:xx秒
        if(time == 0){
            couterHtml =``;

        } else if(time <0){
            couterHtml =` - `;


        }else if (time > 24 * 3600) {
            couterHtml =
                `剩余<em class="m-text-primary">${currTime.days}</em>天`;
        } else {
            couterHtml = `<span class="m-text-danger">${currTime.hours}:${currTime.minutes}:${currTime.seconds}</span>`;
        }
        if (time > 0) {
            setTimeout(_ => {
                __tsIndex.startDateCouter(ele, --time);
            }, 1000);
        } else {

        }

        ele.html(couterHtml);
    },



    checkUserMoblieFun() {
        if (!$('._indexPage').length || $('._loginBtn').length) {
            return;
        }

        ajaxPromise({
            url: '/common/check',
        }).then((data) => {

            if (data.mobile) {
                return;
            }

            layer.open({
                type: 1,
                title: false,
                area: ["660px", '420px'],
                offset: 'auto',
                closeBtn: 0,
                shadeClose: true,
                skin: 'yourclass',
                content: `<div class="login-moblie-modal">
                                <p class="title">绑定其他手机号</p>
                                <p class="desc">为了您的账号安全，请验证您的手机号码</p>
                                <div class="form">
                                    <div class="form-group">
                                        <input type="text" class="phone" placeholder="请输入手机号" maxlength="11">
                                    </div>
                                    <div class="form-group">
                                        <div id="captcha" class="captcha-con"></div>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" class="code" placeholder="请输入验证码">
                                        <a href="javascript:;" class="get-code _sendCode">获取验证码</a>
                                    </div>
                                    <a class="btn _login" href="javascript:;">确认</a>
                                </div>
                            </div>`,
                success: function () {
                    __tsIndex.initCaptchaFun();
                }
            })
        })

    },
    initCaptchaFun(type) {
        initNECaptcha({
            captchaId: '5be5a701dfef49faa1e0e786ecd3647b',
            element: '#captcha',
            onVerify: function (err, data) {
                if (data) {
                    _data.verifyCode = data.validate || '';
                }
            }
        }, function (instance) {
            __tsIndex.initCaptcha = instance;
            // 初始化成功后得到验证实例instance，可以调用实例的方法
        }, function (err) {
            // 初始化失败后触发该函数，err对象描述当前错误信息
        });
    },
    loginFun() {
        const submitData = {
            country_code: 86,
            mobile: $('.phone').val(),
            msg_code: $('.code').val()
        };

        if (!__tsIndex.testDataFun(submitData)) {
            return;
        }

        if (!submitData.msg_code) {
            layer.msg('请输入验证码');
            return;
        }

        ajaxPromise({
            type: "POST",
            url: '/common/bindPhone',
            data: submitData,
        }).then((data) => {

            layer.msg('手机号绑定成功');

            setTimeout(() => {
                window.location.href = data.url;
            }, 1000);
        })
    },
    sendCodeFun() {
        const $this = $(this),
            submitData = {
                mobile: $('.phone').val(),
                country_code: 86,
            };

        if ($this.hasClass('disabled')) {
            return false;
        }


        if (!__tsIndex.testDataFun(submitData)) {
            return;
        }

        ajaxPromise({
            type: "POST",
            url: '/common/sendCode',
            data: submitData,
        }).then((data) => {
            layer.msg('验证码已发送,请注意查收');
            __tsIndex.timeout($this);
        })
    },
    testDataFun(data) {
        const reg = /^1[0-9]{10}$/;

        if (!data.mobile) {
            layer.msg('请输入手机号');
            return;
        }

        if (!reg.test(data.mobile)) {
            layer.msg('请输入正确格式的手机号');
            return;
        }

        if (!_data.verifyCode) {
            layer.msg('请先进行人机交互');
            return;
        }

        return true;
    },
    timeout() {
        let iNow = 60;
        const $code = $('._sendCode');

        clearInterval(__tsIndex.timer);
        __tsIndex.timer = setInterval(() => {
            iNow--;
            $code.html(iNow).addClass('disabled');
            if (!iNow) {
                __tsIndex.resetCodeFun('reset');
            }
        }, 1000);
    },
    resetCodeFun(type) {
        const text = type == 'reset' ? '重新发送' : '获取验证码';

        $('._sendCode').html(text).removeClass('disabled');
        clearInterval(__tsIndex.timer);
        _data.verifyCode = '';
        __tsIndex.initCaptcha.refresh && __tsIndex.initCaptcha.refresh();
    },
    initToastPosFun() {
        const windowW = $(window).width(),
            left = (windowW - 1200) / 2 + 1224;

        $('.xf-toast').css({
            left: windowW > 1500 ? left : 'auto',
            right: windowW > 1500 ? 'auto' : 0
        });
    },
    initLogoFun() {
        let html = '';

        logoArr.forEach((item, index) => {
            html += `${index == 0 || index == 12 ? '<div class="swiper-slide">' : ''}
                    <a class="logo-slide" ${item.url ? 'target="_blank"' : ''} href="${item.url ? item.url : 'javascript:;'}">
                        <img src="/vendors/images/ts/logo${index + 1}.png" alt="">
                        <p>${item.name}</p>
                    </a>
                    ${index == logoArr.length - 1 || index == 11 ? '</div>' : ''}`;
        })

        $('._cbSwiperWrapper').html(html);

        if(__tsIndex.isMobileFlag){
            __tsIndex.initSwiper('._cbSwiper', true);

        }else {
            __tsIndex.initSwiper('._cbSwiper', false);
        }

    },
    initSwiper(swiperItem, ispagination) {
        let swiperObj = {
            autoplay: !ispagination ? false : 4000,
            loop: ispagination
        };

        if (ispagination) {
            swiperObj = Object.assign(swiperObj, {
                pagination: $(swiperItem).find('._pagination'),
                paginationClickable: true,
            })
        } else {
            const $next = $(swiperItem).siblings('._Next'),
                $prev = $(swiperItem).siblings('._Prev');

            swiperObj = Object.assign(swiperObj, {
                prevButton: $prev,
                nextButton: $next,
            })
        }

        new Swiper(swiperItem, swiperObj);
    },
    initScrollFun() {
        const $header = $("#tsHeader"),
            headerH = $header.height();

        scrollFun();

        $(window).on("scroll", function () {
            scrollFun();
        })

        function scrollFun() {
            var st = $("html, body").scrollTop();

            st >= headerH ? $header.addClass('white-bg') : $header.removeClass('white-bg');
        }
    },
    changeSourceTypeFun() {
        const type = $(this).data('type'); // 1：视频  2：图文 3：图集 4:科协辟谣 5：应急避险

        $(this).addClass('active').siblings().removeClass('active');

        if (type == 5) {
            $('._tagCloudList').show();
            $('._sourceList').hide();
        } else {
            $('._sourceList').show();
            $('._tagCloudList').hide();
            __tsIndex.ajaxGetResourceFun(type);
        }
    },
    ajaxGetResourceFun(type) {
        ajaxPromise({
            url: '/tsindex/ajaxGetResource',
            data: {
                type: type
            }
        }).then((data) => {
            if (type == 5) {
                $('._tagCloudList').html(modal({ type, data }));
                __tsIndex.initTagCloudFun();
            } else {
                $('._sourceList').html(modal({ type, data }));
            }
        })
    },
    initTagCloudFun() {
        /*3D标签云*/
        tagcloud({
            selector: ".cloud-content", /*元素选择器*/
            fontsize: 16, /*基本字体大小, 单位px*/
            radius: 130, /*滚动半径, 单位px*/
            mspeed: 'normal', /*滚动最大速度, 取值: slow, normal(默认), fast*/
            ispeed: 'normal', /*滚动初速度, 取值: slow, normal(默认), fast*/
            direction: 130, /*初始滚动方向, 取值角度(顺时针360): 0对应top, 90对应left, 135对应right-bottom(默认)...*/
            keep: false          /*鼠标移出组件后是否继续随鼠标滚动, 取值: false, true(默认) 对应 减速至初速度滚动, 随鼠标滚动*/
        });
    },
    closeToastFun() {
        $(this).parent().remove();
    },
    createLogoSlideFun(sys, arr) {
        let html = '';

        arr.forEach((item, index) => {
            html += `<a class="${sys == 1 ? 'system-slide' : 'logo-slide'}" ${item.url ? 'target="_blank"' : ''} href="${item.url ? item.url : 'javascript:;'}">
                        <img src="${item.logo}" alt="">
                        <p class="row1">${item.title}</p>
                    </a>`;
        })

        return html;
    },
    ajaxGetSystemFun(sys, page, size) {
        ajaxPromise({
            url: '/tsindex/ajaxGetSystem',
            data: {
                type: sys,
                page: page,
                page_size: size
            }
        }).then((data) => {
            const list = data.list;
            let html = __tsIndex.createLogoSlideFun(sys, list);

            $(`._sysSwiper${sys}`).html(html);

            if (data.total <= size) {
                sys == 1 ? __tsIndex.isfinsh1 = true : __tsIndex.isfinsh2 = true;
            } else {
                sys == 1 ? __tsIndex.isfinsh1 = false : __tsIndex.isfinsh2 = false;
            }
        })
    },
    sysHandleFun() {
        const $this = $(this),
            { sys, type } = $this.data(),
            page = sys == 1 ? __tsIndex.page1 : __tsIndex.page2,
            isFinsh = sys == 1 ? __tsIndex.isfinsh1 : __tsIndex.isfinsh2,
            size = sys == 1 ? 18 : 6;

        if ((page <= 1 && type == 'prev') || (isFinsh && type == 'next')) {
            return;
        }

        if (type == 'next') {
            sys == 1 ? __tsIndex.page1++ : __tsIndex.page2++;
        } else {
            sys == 1 ? __tsIndex.page1-- : __tsIndex.page2--;
        }

        __tsIndex.ajaxGetSystemFun(sys, sys == 1 ? __tsIndex.page1 : __tsIndex.page2, size);

    },
    // createSearchParamsFun() {
    //     const keyWord = $('._keywords').val(),
    //         obj = {
    //             title_ids: [],
    //             page_size: 12,
    //             key_word: keyWord
    //         };

    //     $('.search-form-row ._searchItem').each((index, item) => {
    //         const isActive = $(item).hasClass('active'),
    //             { type, id } = $(item).data();

    //         if (isActive) {
    //             type == 'title_ids' ? obj.title_ids.push(id) : obj[type] = id;
    //         }
    //     })

    //     return obj;
    // },
    // createScientificListFun(data, total) {
    //     let html = '',
    //         isLogin = $('._loginBtn').length;

    //     data.forEach((item) => {

    //         html += `${isLogin ? `<a href="javascript:;" data-href="/Tsscientific/detail?id=${item.id}" class="list-item-talent _showLoginModal">` : `<a href="/Tsscientific/detail?id=${item.id}" class="list-item-talent">`}
    //                     <div class="img">
    //                         <img src="${item.avatar}" alt="">
    //                     </div>
    //                     <div class="text-box">
    //                         <p class="name row1">${item.real_name}</p>
    //                         <p class="job row1">${item.classfiy_one_name}-${item.classfiy_two_name}</p>
    //                     </div>
    //                     <p class="company row1">${item.expert_title_name}</p>
    //                 </a>`;
    //     })

    //     $('._scientificList').html(html);
    //     $('.pagination').show();
    //     calculate();
    // },
    // getScientificListFun() {
    //     const url = '/Tsscientific/ajaxGetList',
    //         params = __tsIndex.createSearchParamsFun();


    //     ajaxPromise({
    //         url: url,
    //         data: Object.assign(params, {
    //             page: __tsIndex.scientificPage
    //         })
    //     }).then((data) => {
    //         const total = Number(data.total),
    //             setPage = Math.ceil(total / params.page_size);

    //         __tsIndex.createScientificListFun(data.list);

    //         $('.pagination').pagination({
    //             pageCount: setPage,
    //             jump: true,
    //             coping: true,
    //             showTotalPage: true,
    //             isHide: false,
    //             homePage: '首页',
    //             endPage: '尾页',
    //             prevContent: '上一页',
    //             nextContent: '下一页',
    //             callback: function (api) {
    //                 const params = __tsIndex.createSearchParamsFun();

    //                 console.log('callback')

    //                 ajaxPromise({
    //                     url: url,
    //                     data: Object.assign(params, {
    //                         page: api.getCurrent()
    //                     })
    //                 }).then((data) => {

    //                     __tsIndex.createScientificListFun(data.list);
    //                 })
    //             }
    //         })
    //     })

    // },
    // changeSearchHandleFun() {
    //     const $this = $(this),
    //         { type, id } = $this.data();

    //     if (type == 'classfiy_one') {
    //         __tsIndex.getClassfiyTwoFun(id);
    //     }

    //     if (type == 'title_ids') {
    //         $this.toggleClass('active');
    //     } else {
    //         $this.addClass('active').siblings().removeClass('active');
    //     }

    //     __tsIndex.searchBtnHandleFun();
    // },
    // searchBtnHandleFun() {
    //     // __tsIndex.scientificPage = 1;
    //     // __tsIndex.getScientificListFun();
    // },
    // getClassfiyTwoFun(id) {

    //     if (!id) {
    //         $('._classfiyTwo').html('');
    //         return;
    //     }

    //     ajaxPromise({
    //         url: '/ucenter/getResearchField',
    //         data: { id }
    //     }).then((data) => {
    //         let html = '<a href="javascript:;" class="active _searchItem" data-type="classfiy_two" data-id="0">全部</a>';

    //         data.forEach((item) => {
    //             html += `<a href="javascript:;" class="_searchItem" data-type="classfiy_two" data-id="${item.id}">${item.title}</a>`;
    //         })

    //         $('._classfiyTwo').html(html);
    //     })

    // },
    initSearchItemHeightFun() {
        if(!__tsIndex.isMobileFlag){


            $('._searchFormRow').each((index, item) => {
                const height = $(item).height();
                const itemTop = $(item).offset().top;
                const activeTop = $(item).find('.active').offset().top;

                if (height > 30 && activeTop == itemTop) {
                    $(item).addClass('close').find('._searchHadleBtn').show();
                } else if (height > 30) {
                    $(item).find('._searchHadleBtn').show().text('收起');
                }
            })
        } else {
            $('._searchFormRow').each((index, item) => {
                const height = $(item).height();
                const itemTop = $(item).offset().top;
                const activeTop = $(item).find('.active').offset().top;

                if (height > 30 && activeTop - itemTop >36) {
                    $(item).find('._searchHadleBtn').show().text('收起');

                } else if (height > 30) {
                    $(item).addClass('close').find('._searchHadleBtn').show();

                }
            })

        }

    },
    initOrgSearchItemHeightFun() {

        $('._tabsTitle').each((index, item) => {
            const height = $(item).height();
            const itemTop = $(item).offset().top;
            const activeTop = $(item).find('.active').offset().top;

            if (height > 10 && activeTop == itemTop ) {
                $(item).addClass('close').find('._showMore').show();

            } else if (height > 10) {
                $(item).removeClass('close')
                $(item).find('._showMore').show().text('收起');


            }
        })


    },
    searchRowHandleFun() {
        const $this = $(this),
            $rows = $this.parents('._searchFormRow');

        $rows.toggleClass('close');
        $rows.hasClass('close') ? $this.html('更多') : $this.html('收起');

    },
    // 企业大数据展开或者收起
    handleShowMore(){
        const $this = $(this),
        $rows = $this.parents('._tabsTitle');
        $rows.toggleClass('close');
        $rows.hasClass('close') ? $this.html('更多') : $this.html('收起');


    },
    scrollToNeedsBtnHandleFun() {
        if (window.location.pathname !== '/tsindex') {
            window.location.href = '/tsindex?scrollToNeeds=true';
        } else {
            __tsIndex.scrollToNeedsFun();
        }

    },
    scrollToNeedsFun() {
        const top = $('#needs').offset().top;

        $("html, body").animate({ scrollTop: top + "px" }, 500);
    },
    showPublishListFun() {
        $(this).find('.publish-list').removeClass('hide');
    },
    hidePublishListFun() {
        $(this).find('.publish-list').addClass('hide');
    },

    showLoginModalFun() {
        const href = $(this).data('href'),
            loginUrl = $('._loginBtn').attr('href').split('=')[0],
            url = `${loginUrl}=${window.location.origin}${href}`;

        layer.open({
            type: 1,
            title: false,
            area: ["660px", '300px'],
            offset: 'auto',
            closeBtn: 0,
            shadeClose: true,
            skin: 'yourclass',
            content: `<div class="login-modal">
                        <a class="close _closeBtn"></a>
                        <p>请登录后查看科技人才详情</p>
                        <a class="btn" href="${url}">去登录</a>
                    </div>`
        })

    },
    // 提交反馈意见
    submitFeedback() {
        const formData = $('#feedbackForm').serializeArray(),
            testObj = {
                classify: '请选择反馈类型',
                title: '请输入反馈标题',
                content: '请输入反馈内容',
                contacts_name: '请输入联系人',
                mobile: '请输入联系电话',

            };
            console.log('formData345',formData)


        let flag = true,
            tag = [],
            testContent = true,
            submitData = {};

        for (let i in formData) {
            const name = formData[i].name,
                value = formData[i].value;

            if (!value && flag) {
                layer.msg(testObj[name]);
                flag = false;
            }

            submitData[name] = value;
        }

        if (!flag) {
            return false;
        }
        if(submitData.content.length>200){
            layer.msg('反馈内容最多可填写200字')
            return

        }

        ajaxPromise({
            type: "POST",
            url: '/feedback/ajaxAddAdvice',
            data: submitData,
        }).then((data) => {

            layer.msg('提交成功！');
            setTimeout(function(){
                window.location.reload()
            },1000)
        })
    },
    handleGoBack(){
        window.history.go(-1)

    },
    handleAdvanceSearch(){
        var isLogin=$('#uid').val();
        if(isLogin!='1'){
            layer.msg('请先登录～',{
                time:2000,
            },function(){
                window.location.href='/qichacha/getInfoByQichacha?senior=2';
            })
        }else{
            window.location.href='/qichacha/getInfoByQichacha?senior=2';
        }
    },
    handleSearch(){
        var _keyword=$('[name="keyword"]').val()
        var isLogin=$('#uid').val();
        var form=$('#searchFrom')
        if(isLogin!='1'){
            layer.msg('请先登录～',{
                time:2000,
            },function(){
                window.location.href = "/qichacha/getInfoByQichacha?senior=1&keyword="+_keyword
            })
            return false
        }else{
            form.submit()
        }
    }
};
$(function () {
    __tsIndex.init();


    $(document)
        .on("click", "._sourceTab a", __tsIndex.changeSourceTypeFun)
        .on("click", "._closeToast", __tsIndex.closeToastFun)
        .on("click", "._sysHandleBtn", __tsIndex.sysHandleFun)
        // 科技人才列表搜索
        // .on("click", "._searchItem", __tsIndex.changeSearchHandleFun)
        // .on("click", "._searchBtn", __tsIndex.searchBtnHandleFun)
        .on("click", "._searchHadleBtn", __tsIndex.searchRowHandleFun)
        .on("click", "._scrollToNeeds", __tsIndex.scrollToNeedsBtnHandleFun)
        .on("mouseenter", ".publish-btn", __tsIndex.showPublishListFun)
        .on("mouseleave", ".publish-btn", __tsIndex.hidePublishListFun)

        // 科技人才页 登录弹窗
        .on("click", "._showLoginModal", __tsIndex.showLoginModalFun)
        .on('click', '._login', __tsIndex.loginFun)
        .on('click', '._sendCode', __tsIndex.sendCodeFun)
        .on('change', '.phone', __tsIndex.resetCodeFun)
        .on("click", "._closeBtn", () => {
            layer.closeAll();
        })
        .on("click", "._wait", () => {
            layer.msg('功能开发中');
        })
        // 提交反馈意见
        .on('click', '._submitFeedback', __tsIndex.submitFeedback)
        .on('click', '._goBack', __tsIndex.handleGoBack)
        .on('click', '._showMore', __tsIndex.handleShowMore)
        .on('click', '#advanced-search', __tsIndex.handleAdvanceSearch)
        .on('click', '.searcb-btn', __tsIndex.handleSearch)
})